import { render, staticRenderFns } from "./logoBlue.vue?vue&type=template&id=346a8420&"
import script from "./logoBlue.vue?vue&type=script&lang=js&"
export * from "./logoBlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports